var _defs, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1024,
    zoomAndPan: "magnify",
    viewBox: "0 0 768 767.999994",
    height: 1024,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "id1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "id2"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#id1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -76.8,
    width: 921.6,
    fill: "#000000",
    y: -76.799999,
    height: 921.599993,
    fillOpacity: 0.7882
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "id3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.800781 0.808594 L 459.800781 0.808594 L 459.800781 459.808594 L 0.800781 459.808594 Z M 0.800781 0.808594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 460,
    y: 0,
    height: 461
  })), /*#__PURE__*/React.createElement("mask", {
    id: "id5"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#id1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -76.8,
    width: 921.6,
    fill: "#000000",
    y: -76.799999,
    height: 921.599993,
    fillOpacity: 0.8863
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "id6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.410156 0.632812 L 377.660156 0.632812 L 377.660156 377.882812 L 0.410156 377.882812 Z M 0.410156 0.632812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 378,
    y: 0,
    height: 378
  })), /*#__PURE__*/React.createElement("mask", {
    id: "id8"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#id1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -76.8,
    width: 921.6,
    fill: "#000000",
    y: -76.799999,
    height: 921.599993,
    fillOpacity: 0.6471
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "id9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.957031 0.867188 L 421.707031 0.867188 L 421.707031 421.617188 L 0.957031 421.617188 Z M 0.957031 0.867188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 422,
    y: 0,
    height: 422
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#id2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 76, 247)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#be3e82",
    d: "M 230.300781 0.808594 C 103.550781 0.808594 0.800781 103.558594 0.800781 230.308594 C 0.800781 357.054688 103.550781 459.808594 230.300781 459.808594 C 357.050781 459.808594 459.800781 357.054688 459.800781 230.308594 C 459.800781 103.558594 357.050781 0.808594 230.300781 0.808594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#id5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 34, 30)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e43f6f",
    d: "M 189.035156 0.632812 C 84.859375 0.632812 0.410156 85.082031 0.410156 189.257812 C 0.410156 293.429688 84.859375 377.882812 189.035156 377.882812 C 293.207031 377.882812 377.660156 293.429688 377.660156 189.257812 C 377.660156 85.082031 293.207031 0.632812 189.035156 0.632812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#id8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 324, 135)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id10)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dcedc8",
    d: "M 211.332031 0.867188 C 95.144531 0.867188 0.957031 95.054688 0.957031 211.242188 C 0.957031 327.429688 95.144531 421.617188 211.332031 421.617188 C 327.519531 421.617188 421.707031 327.429688 421.707031 211.242188 C 421.707031 95.054688 327.519531 0.867188 211.332031 0.867188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.38142bd9d4d7719fbeab49d427f9ef25.svg";
export { ForwardRef as ReactComponent };